import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=74589621&scoped=true"
import script from "./Accept.vue?vue&type=script&lang=js"
export * from "./Accept.vue?vue&type=script&lang=js"
import style0 from "./Accept.vue?vue&type=style&index=0&id=74589621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74589621",
  null
  
)

export default component.exports